<template>
  <div class="login">
    <el-container>
      <el-main>
        <el-row :gutter="20">
          <h1 class="text-center">LOGIN</h1>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :span="24" :md="{span: 6, offset: 9}" class="mb-48">
            <el-form ref="loginForm" v-model="loginForm">
              <el-form-item label="User">
                <el-input type="text" id="user" v-model="loginForm.user"></el-input>
                <p>{{loginForm.userError}}</p>
              </el-form-item>
              <el-form-item label="Password">
                <el-input type="password" id="password" v-model="loginForm.password"></el-input>
                <p>{{loginForm.passwordError}}</p>
              </el-form-item>
              <el-button type="primary" @click="formSubmit">提交</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ADMIN from '@/api/admin.js'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      loginForm: {
        user: '',
        userError: '',
        password: '',
        passwordError: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'user'
    ])
  },
  methods: {
    ...mapActions([
      'userLogin'
    ]),
    ...mapMutations([
      'CLEAR_USER'
    ]),
    formSubmit: function () {
      const data = {
        identifier: this.loginForm.user,
        password: this.loginForm.password
      }
      this.CLEAR_USER()
      ADMIN.login(data).then(res => {
        if (res.data && res.data.jwt) {
          this.userLogin(res.data)
          this.$router.push({ name: 'form' })
        }
      })
    },
    resetForm: function () {
      this.loginForm = this.$options.data().loginForm
    }
  }
}
</script>

<style>

</style>
